import { useCallback } from "react";
import type { GridColDef, GridRowIdGetter } from "@mui/x-data-grid";
import { ChildTransaction } from "features/transactions/types";
import { renderers } from "ui/widgets/Table";
import { useTransactionContext } from "../TransactionProvider";

export const useChildTransactions = () => {
    const { children } = useTransactionContext();

    const columns: GridColDef[] = [
        {
            field: 'childTransactionId',
            headerName: 'Child Transaction ID',
            flex: 1,
            minWidth: 150
        },
        {
            field: 'childAmount',
            headerName: 'Child Amount',
            flex: 1,
            minWidth: 100
        },
        {
            field: 'childCurrency',
            headerName: 'Child Currency',
            flex: 1,
            minWidth: 100
        },
        {
            field: 'childStatus',
            headerName: 'Child Status',
            flex: 1,
            minWidth: 120,
            renderCell: renderers.TransactionStatus
        },
        {
            field: 'childFundsStatus',
            headerName: 'Child Funds Status',
            flex: 1,
            minWidth: 130,
            renderCell: renderers.FundStatus
        },
        {
            field: 'childDirection',
            headerName: 'Child Direction',
            flex: 1,
            minWidth: 120,
            renderCell: renderers.Direction
        },
        {
            field: 'childReason',
            headerName: 'Child Reason',
            flex: 1,
            minWidth: 200
        },
        {
            field: 'childReasonCode',
            headerName: 'Child Reason Code',
            flex: 1,
            minWidth: 120
        },
        {
            field: 'childCreatedAt',
            headerName: 'Child Created At',
            flex: 1,
            minWidth: 180
        },
        {
            field: 'childUpdatedAt',
            headerName: 'Child Updated At',
            flex: 1,
            minWidth: 180
        }
    ];

    const getRowId: GridRowIdGetter<ChildTransaction> = useCallback(({ childTransactionId }) => childTransactionId, []);

    return {
        columns,
        rows: children,
        getRowId
    };
};

export default useChildTransactions;
